import styled from '@emotion/styled';

import { inputFontSize, inputHeightLarge } from './InputField';
import styles from '../../constants/styles';
import { getSemanticColorVariable } from '../../theme/colors';

// Local Typings
interface Props {
  error?: boolean;
  isDisabled: boolean;
  isEditable: boolean;
  isFocused?: boolean;
  rounded?: boolean;
  transition: number;
}

// Local Variables
function getFocusBorderColor(props: Props) {
  return props.error
    ? getSemanticColorVariable('input_border_focus_danger')
    : getSemanticColorVariable('input_border_focus_default');
}

function getBorderColor(props: Props) {
  if (props.isFocused) {
    return getFocusBorderColor(props);
  }

  return props.error
    ? getSemanticColorVariable('input_border_danger')
    : getSemanticColorVariable('input_border_default');
}

// Component Definition
const InputBorder = styled.div<Props>(props => ({
  alignItems: 'center',
  backgroundColor: props.isDisabled
    ? getSemanticColorVariable('input_background_disabled')
    : getSemanticColorVariable('input_background_default'),
  border: `${styles.borderWidths.default}px solid`,
  borderColor: getBorderColor(props),
  borderRadius: props.rounded ? inputHeightLarge / 2 : 4,
  color: getSemanticColorVariable('text_default'),
  display: 'flex',
  flexWrap: 'nowrap', // this is here so the datepicker inputs do not wrap when the table drawer opens
  fontSize: `${inputFontSize}px`,
  outline: 'none',
  overflowX: 'hidden',
  position: 'relative',
  transition: `${props.transition}ms`,
  width: '100%',
}));

export default InputBorder;
